import Client from "./client";

const baseUrl = `/api/1/wallets`;

function wallets() {
  return {
    assignAddressToWallet: (walletDto) => {
      return Client.put(baseUrl + `/address`, walletDto);
    },
    getCurrencies: () => {
      return Client.get(baseUrl + `/currencies`);
    },

    getMyWallets: () => {
      return Client.get(baseUrl + `/self`);
    },

    get: (id) => {
      return Client.get(baseUrl + `/${id}`);
    },

    getMyWalletsBallance: () => {
      return Client.get(baseUrl + `/self/balance`);
    },

    getTotalBalances: () => {
      return Client.get(baseUrl + `/totalBalances`);
    },
    getWalletBalance: () => {
      return Client.get(baseUrl + `/self/balance`);
    },
    getMyWalletByCurrency: ({ params }) => {
      return Client.get(baseUrl + `/self/currency/${params.currencyName}`);
    },
    updateFavoriteCurrencies: ({ payload }) => {
      const url = baseUrl + `/update/favorite`;
      return Client.put(url, payload);
    },
  };
}

export default wallets();
